import { VTOColor, VTO_ZState, VTOColorOptions } from 'components/VTO/VTO.interfaces';
import { ColorTaxonomyType, FrameShape } from 'constants/dataTypes';
import { slugToString } from 'functions/slug';
import { create } from 'zustand'

export const useVTOStore = create<VTO_ZState>((set) => ({
    customTitle: undefined,
    isVisible: false,
    frameColors: null,
    armColors: null,
    categorySlug: undefined,
    selectedColors: {
        frame: '',
        arm: '',
        lens: '',
        shape: ''
    },
	minPrice : undefined,
	regularPrice : undefined,
    updateParent : false,
    setUpdateParent: (_updateParent:boolean) => set((state) => ({
        ...state,
        updateParent: _updateParent
    })),
    setCategory: (_categorySlug:string) => set((state) => ({
        ...state,
        categorySlug: _categorySlug
    })),
	setCustomTitle: (_customTitle:string) => set((state) => ({
        ...state,
        customTitle: _customTitle
    })),
    clearCustomTitle: () => set((state) => ({
        ...state,
        customTitle: undefined
    })),
    setPrice: (_minPrice:number, _regularPrice:number) => set((state) => ({
        ...state,
        minPrice: _minPrice,
        regularPrice: _regularPrice
      })),
    setSelectedColors: (frame: string, arm: string, lens: string, shape: string) => set(state => {
        // console.log('setSelectedColors', frame, arm, lens);
        const stateNew = {
            ...state,
            selectedColors: {
                frame: frame,
                arm: arm,
                lens: lens,
                shape: shape
            }
        }
        return stateNew;
    }),
    updateVisibility: (_isVisible: boolean) => set(state => {
        const stateNew = {
            ...state,
            isVisible: _isVisible,
            customTitle: _isVisible ? state.customTitle : undefined // Clear custom title when closing modal
        }
        if(_isVisible) {
            stateNew.updateParent = false;
        }
        return stateNew;
    }),
    // eslint-disable-next-line no-unused-vars
    setColors: (locale:string|undefined, colors: ColorTaxonomyType[]) => set(state => {
        const colorsVTO : VTOColor[] = [];

        colors.map((color) => {
            colorsVTO.push({
                id: color.slug,
                title: color.name,
                hex: '#' + color.color
              });
        });
        return ({
            updateParent: false,
            minPrice: undefined,
            regularPrice: undefined,
            frameColors: colorsVTO,
            armColors: colorsVTO,
        })
     }),
    vtoColorOptions: null,
    setVtoColorOptions: (options: VTOColorOptions) => set(state => {
        const frameColors = options.vto_frame_colors.flatMap(frameColor => 
            frameColor.colors.map(color => ({
                id: color,
                title: slugToString(color),
                hex: '#' + options.colorLookup.find(c => c.color === color)?.hex || '#000000',
                shape: frameColor.shape
            }))
        );

        const armColors = options.vto_arms_colors.map(color => ({
            id: color,
            title: slugToString(color),
            hex: '#' + options.colorLookup.find(c => c.color === color)?.hex || '#000000'
        }));

        return {
            ...state,
            vtoColorOptions: options,
            frameColors,
            armColors
        };
    }),
}));